import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { DAY_IN_MS } from '@office-start/date-utility';
import { getDeviceInfo, getPlatformVersionString, } from '@office-start/device-detection-utility';
import { createSimpleStaleWhileRevalidateOperation, } from '@office-start/persistence-strategies';
import { createExpirationPlugin, readFromSimplePersistence, writeToSimplePersistence, } from '@office-start/simple-persistence';
import { fetchUserEntitlements } from '@office-start/user-entitlements-service';
import { fullDaysSinceFirstVisit } from '@office-start/user-storage-service';
import { fetchTemplateContentData } from '../operations/fetchTemplateContentData';
// Constants
var templatesPersistenceVersion = 1;
export function executeTemplateContentDataFlow(app, templateId, templateBinaryUrl, identity, officeComponentContext, TemplatesConfig, handleRevalidation) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var userEntitlements, deviceInfo, options, templatesPersistenceKey;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetchUserEntitlements()];
                case 1:
                    userEntitlements = (_b.sent()).result;
                    deviceInfo = getDeviceInfo();
                    options = {
                        correlationId: officeComponentContext.correlationId,
                        getAccessToken: officeComponentContext.getAccessToken,
                        getIdentity: function () { return Promise.resolve(identity); },
                        inMockMode: officeComponentContext.inMockMode,
                        jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
                        workload: officeComponentContext.workload,
                        officeHomeApiRoot: officeComponentContext.officeHomeApiRoot,
                        app: app,
                        templateId: templateId,
                        templateBinaryUrl: templateBinaryUrl,
                        templatesApiEndpoint: TemplatesConfig.templatesApiEndpoint,
                        officeMarket: officeComponentContext.preferredCulture,
                        show: TemplatesConfig.numTemplates - 1,
                        browserName: deviceInfo.browser.browserType,
                        flights: ((_a = officeComponentContext.flights) === null || _a === void 0 ? void 0 : _a.replace(/,\s*$/, '')) || '',
                        isPremium: false,
                        isIw: (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.IsIw) || false,
                        isAdmin: (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.IsAdmin) || false,
                        isSmb: (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.IsSmb) || false,
                        isEdu: (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.IsEdu) || false,
                        isEduFaculty: (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.IsEduFaculty) || false,
                        isEduStudent: (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.IsEduStudent) || false,
                        authId: identity.isMsa ? 1 : 2,
                        firstVisitAgeInWeeks: Math.floor(fullDaysSinceFirstVisit() / 7),
                        page: 'Create',
                        deploymentEnvironment: officeComponentContext.deploymentEnvironment || '',
                        osName: deviceInfo.platform.platformType,
                        osVersion: getPlatformVersionString(deviceInfo.platformVersion),
                    };
                    templatesPersistenceKey = 'templates-content-api-rc' +
                        '-' +
                        createPersistenceKey(templateId, options.officeMarket);
                    return [2 /*return*/, createSimpleStaleWhileRevalidateOperation(function () { return fetchTemplateContentData(options); }, function () {
                            var plugins = getTemplatesPersistencePlugins();
                            // Reverse order of plugins used for write so they play back
                            // in the correct order.
                            var pluginsForRead = __spreadArray([], __read(plugins), false).reverse();
                            return readFromSimplePersistence({
                                userId: identity.puid,
                                collectionName: templatesPersistenceKey,
                                collectionVersion: templatesPersistenceVersion,
                                key: createPersistenceKey(templateId, options.officeMarket),
                                plugins: pluginsForRead,
                            });
                        }, function (networkPayload) { return __awaiter(_this, void 0, void 0, function () {
                            var plugins;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        plugins = getTemplatesPersistencePlugins();
                                        return [4 /*yield*/, writeToSimplePersistence({
                                                userId: identity.puid,
                                                collectionName: templatesPersistenceKey,
                                                collectionVersion: templatesPersistenceVersion,
                                                key: createPersistenceKey(templateId, options.officeMarket),
                                                data: networkPayload,
                                                plugins: plugins,
                                            })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, handleRevalidation)];
            }
        });
    });
}
function createPersistenceKey(key, locale) {
    return key + '_' + locale;
}
function getTemplatesPersistencePlugins() {
    return [createExpirationPlugin(7 * DAY_IN_MS)];
}
//# sourceMappingURL=executeTemplateContentDataFlow.js.map